import React from 'react';

import { BaseContainer } from '../../layout/BaseContainer';

export function HomePage() {
  return (
    <BaseContainer />
  );
}
